import React from 'react';
import { artistInfo, images } from '../data/mock';
import { Play } from 'lucide-react';

const HeroSection = () => {
  const scrollToVideo = () => {
    const element = document.getElementById('video');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={images.hero}
          alt="Laura Sommerfeld"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black"></div>
        {/* Metallic Shimmer Effect */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 via-transparent to-cyan-400/10 animate-pulse"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto space-y-8">
          {/* Animated Badge */}
          <div className="inline-block animate-fade-in">
            <span className="inline-block px-6 py-2 bg-gradient-to-r from-blue-500/20 to-cyan-400/20 backdrop-blur-sm border border-blue-400/30 rounded-full text-blue-300 text-sm font-medium uppercase tracking-widest">
              Schlagersängerin
            </span>
          </div>

          {/* Name */}
          <h1 className="text-6xl md:text-8xl lg:text-9xl font-bold text-white animate-fade-in-up">
            <span className="bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-400 bg-clip-text text-transparent">
              Laura
            </span>
            <br />
            <span className="text-white">Sommerfeld</span>
          </h1>

          {/* Tagline */}
          <p className="text-xl md:text-2xl text-gray-300 animate-fade-in-delay font-light tracking-wide">
            {artistInfo.tagline}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-delay-2">
            <button
              onClick={scrollToVideo}
              className="group relative px-8 py-4 bg-gradient-to-r from-blue-500 to-cyan-400 text-white rounded-full font-medium uppercase tracking-wider transition-all duration-300 hover:shadow-2xl hover:shadow-blue-500/50 hover:scale-105 overflow-hidden"
            >
              <span className="relative z-10 flex items-center gap-2">
                <Play size={20} />
                Neues Video ansehen
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-400 to-blue-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>
            
            <a
              href={artistInfo.spotifyEmbedUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white rounded-full font-medium uppercase tracking-wider transition-all duration-300 hover:bg-white/20 hover:border-white/50 hover:scale-105"
            >
              Musik anhören
            </a>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-blue-400 rounded-full animate-scroll"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
